import { Injectable } from '@angular/core';

import { ConfigService, EntityService } from 'viggo-sistemas-core-web';

import { IParceiro } from '../model';

@Injectable()
export class ParceiroService<
  T extends IParceiro = IParceiro
> extends EntityService<T> {
  constructor(protected configService: ConfigService) {
    super({
      urlBackend: configService.backendURL,
      baseEntityEndPoint: 'parceiro'
    });
  }
}
